module.exports = __webpack_public_path__ + "static/img/join.6a8f8d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/join.png
// module id = xJDj
// module chunks = 24